import { Logs, Master, } from "../../../assets/svg-icons";
import { processNodeAndPermissions } from "../../../helper/com-helper";

export interface ChildNode {
  name: string;
  route: string | null;
  permissions: string[];
  icon?: React.FC<{ color: string }>;
  shortName?: string;
  child?: Record<string, ChildNode>;
}

export interface DHInterface extends ChildNode {
  child: Record<string, ChildNode>;
}

const DH_OBJECT: DHInterface = {
  name: "Health Monitor",
  route: "/dh/product",
  shortName: "DH",
  icon: Logs,
  permissions: [],
  child: {
    "Demo Child": {
          name: "Demo Child",
          route: "/dh/product",
          permissions: ["HEALTH_VIEW"],
          icon: Master,
          shortName: "Demo",

    }
  }
};

processNodeAndPermissions(DH_OBJECT);

export const DH = DH_OBJECT;
